import React from 'react';

const Git = () => {
    return (
        <div>
            <p style={{color: '#fff'}}>Git</p>
        </div>
    );
};

export default Git;